import AWS from "aws-sdk";
import { s3, S3_BUCKET } from "./AwsConfig";
 
const uploadImagetos3=async (file)=>{
 
    const fileKey = `products/${Date.now()}-${file.name}`;

    const params = {
      Bucket: S3_BUCKET,
      Key: fileKey,
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
    };

    try {
      const { Location } = await s3.upload(params, {
        partSize: 10 * 1024 * 1024, // 10MB part size (adjust as needed)
      }).on('httpUploadProgress', (progress) => {
        const progressPercentage = Math.round((progress.loaded / progress.total) * 100);
        console.log(`Upload Progress: ${progressPercentage}%`);
      }).promise();

      console.log("Uploaded File URL:", Location);
      return Location;
    } catch (error) {
      console.error("S3 Upload Error:", error);
    } finally {
    }
    
  };
  export default uploadImagetos3;
    
